<template>
  <div class="box">
    <!-- 下面版权 -->
    <div class="box-bottom">
      <!-- 右边固定部分 -->
      <div class="middle-back">
        <div class="mid-back-con">
          <div class="mid-back-one mid-back-img-one">
            <div class="mid-back-two">
              <div class="mid-back-two-con">
                <p>联系电话(微信同号)</p>
                <p>15628831001</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mid-back-con">
          <div class="mid-back-one mid-back-img-two"></div>
          <div class="mid-back-two">
            <div class="mid-back-two-con">
              <p>扫码进入 华美家</p>
              <img src="../pro/二维码.webp" alt="" />
            </div>
          </div>
        </div>
        <div class="mid-back-con mid-back-hide" @click="toTop">
          <div class="mid-back-one mid-back-enm"></div>
        </div>
      </div>

      <div class="box-bottomCon clearfix">
        <div class="box-bottomConOne box-bottomOne">
          <ul>
            <li>北京西三环北路72号世纪经贸大厦B座22层</li>
            <br />
            <li>电子邮箱149495795@qq.com</li>
            <br />
            <li>客服电话（微信同号）156 2883 1001</li>
          </ul>
        </div>
        <div class="box-bottomConTwo box-bottomOne">
          <ul>
            <li>绿色装修，健康生活</li>
            <li>
              <img src="../pro/京公网.webp" alt="" />
              京公网安备11010802044665号 京ICP备2024065794号 <br />
              版权所有 © 北京国禀科技有限公司
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
    
<script>
export default {
  name: "contentBut",
  methods: {
    // 返回顶部
    toTop() {
      document.documentElement.scrollTop = 0;
    },
  },
};
</script>
    
<style lang="scss" scoped>
// 最下面
.box-bottom {
  background: #17181e;
  color: #fff;
  // margin-top: 2rem;

  .box-bottomCon {
    max-width: 70rem;
    margin: 0 auto;
    display: block;

    .box-bottomOne {
      width: 50%;
      float: left;
      box-sizing: border-box;
    }
    .box-bottomConOne {
      margin: 3rem 0;
      border-right: 1px solid rgba($color: #fff, $alpha: 0.7);
    }
    .box-bottomConOne ul {
      width: 60%;
      margin: 2rem auto;
    }
    .box-bottomConOne ul li {
      font-size: 0.9rem;
      opacity: 0.5;
      line-height: 1.5rem;
    }
    .box-bottomConTwo ul {
      width: 77%;
      margin: 4rem auto;
      opacity: 0.79;
    }
    .box-bottomConTwo ul li:last-child {
      opacity: 0.5;
      margin-top: 1.4rem;
      line-height: 1.5rem;
    }
    .box-bottomConTwo img {
      width: 0.7rem;
      height: 0.7rem;
    }
  }

  /* 右边固定部分  客服 回到首页 */
  .middle-back {
    position: fixed;
    right: -16px;
    top: 70%;
    transform: translateY(-50%);
    width: 4rem;
    z-index: 9;
    .mid-back-con {
      position: relative;
      width: 4rem;
    }
    .mid-back-hide {
      margin-top: 50px;
    }
    .mid-back-one {
      cursor: pointer;
      background: #fff;
      border-radius: 0.0625rem;
      text-align: center;
      font-size: 12px;
      font-weight: 400;
      display: flex;
      flex-direction: column;
      justify-content: center;
      transition: background-color 0.3s, color 0.3s;
    }
    .mid-back-two {
      display: none;
      position: absolute;
      top: 0;
      left: -204px;
      background-color: #fff;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      overflow: hidden;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
      /* display: flex;
        justify-content: flex-start;
        align-items: center; */
    }
    .mid-back-two-con {
      width: 172px;
    }
    .mid-back-two-con p {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.65);
      text-align: center;
      line-height: 18px;
    }
    .mid-back-two-con img {
      width: 142px;
    }
    .mid-back-img-one {
      width: 4rem;
      height: 3rem;
      padding: 0;
      margin-bottom: 0;
      background: url(../pro/kf.webp);
      background-size: contain;
      background-repeat: no-repeat;
    }
    .mid-back-img-one:hover {
      background: url(../pro/kfjg.webp);
      background-size: contain;
      background-repeat: no-repeat;
    }
    .mid-back-img-two {
      width: 4rem;
      height: 3rem;
      padding: 0;
      margin-bottom: 0;
      background: url(../pro/sc.webp);
      background-size: contain;
      background-repeat: no-repeat;
    }
    .mid-back-img-two:hover {
      background: url(../pro/scjg.webp);
      background-size: contain;
      background-repeat: no-repeat;
    }
    .mid-back-enm {
      width: 4rem;
      height: 3rem;
      padding: 0;
      margin-bottom: 0;
      background: url(../pro/db.webp);
      background-size: contain;
      background-repeat: no-repeat;
    }
    .mid-back-enm:hover {
      background: url(../pro/dbjg.webp);
      background-size: contain;
      background-repeat: no-repeat;
    }
    .mid-back-con:hover .mid-back-two {
      display: block;
    }
  }
}

@media (max-width: 768px) {
  .box-bottom {
    .box-bottomCon {
      .box-bottomOne {
        width: 100%;
      }
      .box-bottomConOne {
        margin: 3rem 0 0;
        padding-bottom: 2rem;
        border-right: initial;
        border-bottom: 1px solid rgba($color: #fff, $alpha: 0.5);
      }
      .box-bottomConOne ul {
        width: 80%;
        margin: auto;
      }
      .box-bottomConTwo ul {
        width: 77%;
        margin: 2rem auto;
      }
      .box-bottomConTwo ul li {
        display: block;
      }
    }
  }
}
</style>